import './shippingAndPoliciesSection.scss';
import { FC } from 'react';

import { translations } from 'translations/en';
import ShippingPolicyRow from './ShippingPolicyRow';
import { IShippingAndPoliciesSection } from 'types';

const {
  TITLE,
  BUYERS_RESPONSIBLE_DESCRIPTION,
  BUYERS_RESPONSIBILITY,
  CUSTOM_AND_IMPORT_TAXES,
  RETURNS_AND_EXCHANGES,
  READY_TO_SHIP_IN,
  SHIPS_TO,
  SHIPS_FROM,
} = translations.SPECIFIC_PRODUCT.SHIPPING_AND_POLICIES;

const ShippingAndPoliciesSection: FC<IShippingAndPoliciesSection> = ({ shippingInformation }) => {
  const { processingTime, returnPolicy, originCountry, countries } = shippingInformation;

  let processingDaysText = `${processingTime.min}-${processingTime.max}`;
  if (processingTime.min === processingTime.max) {
    processingDaysText = String(processingTime.min);
  }

  const processingDays = `${processingDaysText} business days`;

  const shippingCountries = countries.join(', ');

  const subTitles = returnPolicy?.title || '-';

  const returnPolicyDescription = returnPolicy?.description || '-';

  return (
    <div className="shipping-policies-container">
      <span className="title">{TITLE}</span>
      <ShippingPolicyRow
        title={READY_TO_SHIP_IN}
        subTitle={processingDays}
        description={null}
        isExpandableText={false}
      />
      <ShippingPolicyRow
        title={SHIPS_FROM}
        subTitle={originCountry}
        description={null}
        isExpandableText={false}
      />
      <ShippingPolicyRow
        title={SHIPS_TO}
        subTitle={shippingCountries}
        description={null}
        isExpandableText
      />
      <ShippingPolicyRow
        title={RETURNS_AND_EXCHANGES}
        subTitle={subTitles}
        description={returnPolicyDescription}
        isExpandableText={false}
      />
      <ShippingPolicyRow
        title={CUSTOM_AND_IMPORT_TAXES}
        subTitle={BUYERS_RESPONSIBILITY}
        description={BUYERS_RESPONSIBLE_DESCRIPTION}
        isExpandableText={false}
      />
    </div>
  );
};

export default ShippingAndPoliciesSection;
